import React from 'react'

function PageNotFound() {
    return (
        <div style={{padding: '80px 40px', textAlign: 'center'}}>
            <h1><span style={{fontSize: '3rem'}}>Error 404</span>: page not found</h1>
        </div>
    )
}

export default PageNotFound